export enum SubmissionStatus {
  Pending = 'PENDING',
  CoolingOff = 'COOLING_OFF',
  Passed = 'PASSED',
  Failed = 'FAILED',
  Aborted = 'ABORTED',
  Expired = 'EXPIRED',
}
